import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useFormik } from "formik";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import { createDireccionFormValidate } from "../../../../helper/validate";

const AddressView = forwardRef(({ item, callNewEditModal }, ref) => {
  useEffect(() => {
    formik?.resetForm();
  }, [item]);

  let initialValues = {
    isNew: true,
    id: 0,
    nombre: "",
    calle: "",
    noExterior: "",
    noInterior: "",
    colonia: "",
    cp: "",
    referencia: "",
    ciudad: "",
    estado: "",
  };

  if (item && Object.keys(item).length > 0) {
    initialValues = {
      id: item.id,
      nombre: item.nombre,
      calle: item.calle,
      noExterior: item.noExterior,
      noInterior: item.noInterior,
      colonia: item.colonia,
      cp: item.cp,
      referencia: item.referencia,
      ciudad: item.ciudad,
      estado: item.estado,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createDireccionFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.log("dddd");
    },
  });

  // used useImperativeHandle here
  useImperativeHandle(ref, () => ({
    clear: () => {
      formik.resetForm();
    },
    getValues: () => {
      const values = formik.values;
      if (values.isNew) {
        values.id = Date.parse(Date());
      }
      return values; //"internalRef.current.value";
    },
    validate: () => {
      const isValid = formik.values.nombre.length > 0;
      formik.handleSubmit();
      return isValid;
    },
  }));

  /*  useEffect(() => {
    return () => {
      callNewEditModal(formik.values);
    };
  }, []);*/

  return (
    <div className="">
      <div className="row">
        <div className="col-8">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Nombre
          </label>
          <input
            {...formik.getFieldProps("nombre")}
            {...formikExtra.upperCase("nombre", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.nombre)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div className="valid-feedback"></div>
          <div className="invalid-feedback">{formik.errors.nombre}</div>
        </div>
        <div className="col-4">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Codigo Postal
          </label>
          <input
            {...formik.getFieldProps("cp")}
            {...formikExtra.upperCase("cp", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.cp)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Calle
          </label>
          <input
            {...formik.getFieldProps("calle")}
            {...formikExtra.upperCase("calle", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.calle)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputColonia" className="form-label">
            Colonia
          </label>
          <input
            {...formik.getFieldProps("colonia")}
            {...formikExtra.upperCase("colonia", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.colonia)}`}
            id="validationColonia"
            aria-describedby="coloniaHelp777"
          />
          <div id="coloniaHelp" className="form-text"></div>
        </div>
      </div>

      <div className="row">
        <div className="col-4">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Estado
          </label>
          <input
            {...formik.getFieldProps("estado")}
            {...formikExtra.upperCase("estado", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.estado)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>
        {/*<div className="col-4">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Municipio
          </label>
          <input
            {...formik.getFieldProps("municipality")}
            type="text"
            className={`form-control ${invalidClass(
              formik.errors.municipality
            )}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>*/}
        <div className="col-4">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Ciudad
          </label>
          <input
            {...formik.getFieldProps("ciudad")}
            {...formikExtra.upperCase("ciudad", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.ciudad)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>
        <div className="row">
          <div className="col-4">
            <label htmlFor="exampleInputEmail1" className="form-label">
              Numero Exterior
            </label>
            <input
              {...formik.getFieldProps("noExterior")}
              {...formikExtra.upperCase("noExterior", formik)}
              type="text"
              className={`form-control ${invalidClass(
                formik.errors.noExterior
              )}`}
              id="validationEmail"
              aria-describedby="emailHelp777"
            />
            <div id="emailHelp" className="form-text"></div>
          </div>
          <div className="col-4">
            <label htmlFor="exampleInputEmail1" className="form-label">
              Numero Interior
            </label>
            <input
              {...formik.getFieldProps("noInterior")}
              {...formikExtra.upperCase("noInterior", formik)}
              type="text"
              className={`form-control ${invalidClass(
                formik.errors.noInterior
              )}`}
              id="validationEmail"
              aria-describedby="emailHelp777"
            />
            <div id="emailHelp" className="form-text"></div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Referencias
          </label>
          <textarea
            {...formik.getFieldProps("referencia")}
            {...formikExtra.upperCase("referencia", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.referencia)}`}
            style={{ resize: false }}
            id="validationEmail"
            aria-describedby="emailHelp777"
            rows="3"
          />
          <div id="emailHelp" className="form-text"></div>
        </div>
      </div>
    </div>
  );
});

export default AddressView;
